import consumer from "./consumer";

let exportsSubscription = null;

export function subscribeToExportsChannel(currentUserId) {
  if (!currentUserId) {
    return null;
  }

  if (exportsSubscription) {
    return exportsSubscription;
  }

  exportsSubscription = consumer.subscriptions.create({ channel: "ExportsChannel", user_id: currentUserId }, {
    connected() {
      // noop
    },
    disconnected() {
      exportsSubscription = null;
    },
    received(data) {
      if (window.ReportExports && typeof window.ReportExports.upsert === "function") {
        window.ReportExports.upsert(data);
      }
    }
  });

  return exportsSubscription;
}
